import 'bootstrap-datepicker';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.pl';

$('.winners-calendar-container').each(function() {
    let that = this,
        $calendar = $('.winners-calendar', that);

    const allowedDates = $calendar.data('allowed-dates').split(',');

    $calendar.datepicker({
        format: 'yyyy-mm-dd',
        startDate: $(this).data('min'),
        endDate: $(this).data('max'),
        defaultViewDate: 'today',
        startView: 'days',
        minViewMode: 'days',
        maxViewMode: 'days',
        keyboardNavigation: false,
        weekStart: 1,
        language: 'pl',
        beforeShowDay: (date) => {
            const hasWinners = allowedDates.includes(`${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`);

            return {
                classes: hasWinners ? '' : 'no-winners',
            }
        }
    })
    .on('changeDate', function () {
        let selectedDate = $(this).datepicker('getFormattedDate');
        $('.winners-calendar-date', that).text(selectedDate.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3.$2.$1'));
        $('.winners-calendar-list > *', that).addClass('d-none');

        let winnersLength = 0;
        $('.winners-calendar-list', that).each(function () {
            let $winners = $(`[data-date=${selectedDate}]`, this);
            winnersLength += $winners.length;
            if($winners.length > 0) {
                $(this).parent('.winners__box').show(400);
                $winners.removeClass('d-none');
            } else {
                $(this).parent('.winners__box').hide(400);
            }
        })
        $('.winners-calendar-list-empty', that).toggleClass('d-none', !!winnersLength);
    })
    .datepicker('update', allowedDates.toSorted()[allowedDates.length-1])
    .trigger('changeDate');
});